import { AxiosResponse } from "axios";
import { API } from "../index";
import { Page } from "../type";

export interface CouponBookRulePayload {
  coupon_product: number;
  start_date: string;
  end_date: string;
  state: string;
  stock: number;
  type: string;
  usage_amount: number;
  usage_period_day: number;
  target_sites: number[];
}

export const couponService = {
  getCouponBook: async (): Promise<AxiosResponse> => {
    return await API.get(`/coupon/book/`);
  },

  postCouponDownById: async (couponId: number): Promise<AxiosResponse> => {
    return await API.post(`/coupon/book/download/${couponId}/`);
  },

  getCouponsByPage: async (page: number): Promise<AxiosResponse> => {
    return await API.get(`/coupon/user/?page=${page}`);
  },

  getCouponGiftList: async (pageParam: number): Promise<AxiosResponse> => {
    return await API.get(`/coupon/user/?page=${pageParam}&gifted=true`);
  },

  putReceptCouponById: async (couponId: number): Promise<AxiosResponse> => {
    return await API.put(`/coupon/gift/reception/${couponId}/`);
  },

  putCouponSendCancelById: async (couponId: number): Promise<AxiosResponse> => {
    return await API.put(`/coupon/gift/cancel/${couponId}/`);
  },

  listCouponBookRules: async (): Promise<AxiosResponse> => {
    return await API.get(`/coupon/rules/?include_hidden=true`);
  },

  createCouponBookRule: async (payload: CouponBookRulePayload): Promise<AxiosResponse> => {
    return await API.post(`/coupon/rules/`, payload);
  },

  updateCouponBookRule: async (id: number, payload: CouponBookRulePayload): Promise<AxiosResponse> => {
    return await API.put(`/coupon/rules/${id}/`, payload);
  },

  deleteCouponBookRule: async (id: number): Promise<AxiosResponse> => {
    return await API.delete(`/coupon/rules/${id}/`);
  },

  // Pre-coupons
  getUserPreCoupons: async (page: number = 1): Promise<AxiosResponse> => {
    return await API.get(`/precoupon/user/?page=${page}&state=사용안함`);
  }
};

export const sendUserCouponGift = async (couponId: string, phoneNum: string) => {
  return API.post("/coupon/gift/send/", {
    user_coupon_id: couponId,
    phone_num: phoneNum,
  });
};

export const sendUserCouponKakao = async (couponId: string, kakaoId: string) => {
  return API.post("/coupon/gift/send/kakao/", {
    coupon_id: couponId,
    kakao_id: kakaoId,
  });
};

export const giftCouponByUrl = async (couponId: string) => {
  return API.post(`/coupon/gift/send/url/`, {
    user_coupon_id: couponId,
  });
};
